import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Img from "../../../images/locationgcc/bh/Boost.webp";

function Banner(props) {
  return (
    <div className="experienced p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Work with Expert App Developers in Bahrain to Create A Dynamic
              Application
            </h2>
            <p>
              The quality of your mobile app highly depends on its development
              team. TekRevol is proud to have a diverse team of master
              developers who have provided their expertise in multiple projects.
              We hire the top 1% of app developers in Bahrain to ensure the
              delivery of a product that not only optimizes the business
              operation but also sets a trend in the global market. Having
              adaptive capabilities in different stacks for variable mobile
              apps, we craft dynamic applications to facilitate a wide range of
              audiences.
            </p>
            <p>
              As a result, you will streamline your business while leveraging
              the opportunity to scale it across the industry at a global level.
              We’ve already set our mark of excellence and it is time for
              Bahrain to experience the next-gen mobile app development service
              for business digitization.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Let’s Get Started
            </Link>
          </Col>
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <LazyLoadImage
              src={Img}
              effect="blur"
              alt="mobile app development Bahrain"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
